import { render } from "./Measurements.vue?vue&type=template&id=c04aa85c"
import script from "./Measurements.vue?vue&type=script&lang=js"
export * from "./Measurements.vue?vue&type=script&lang=js"
script.render = render

export default script